/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "../../../Pages/AdminScreens/LeaveBalance/LeaveBalance.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { MdSearch } from "react-icons/md";
import tableimg from "../../../Assets/Images/tableimage.jpg";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import { Apiurl, GetToken } from "../../../Utils/utils";
import axios from "axios";
import dummyimage from "../../../Assets/Images/dummyimg.png";

const LeaveBalance = () => {
  const [showSidebar, setShowSidebar] = useState(true);
  const [leaveRequestDuplicate, setLeaveRequestDuplicate] = useState([]);

  const LoginToken = GetToken();
  const [LeaveBalance, setLeaveBalence] = useState([]);
  const GetLeaveBalance = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/LeaveBalance`,
    };
    axios(option)
      .then((e) => {
        const data = JSON.parse(e?.data?.data);
        setLeaveBalence(data);
        setLeaveRequestDuplicate(data);
      })
      .catch(() => {
      });
  };

  useEffect(() => {
    GetLeaveBalance();
  }, []);

  const handleDataSearch = (e) => {
    const searchTerm = e?.target?.value?.toLowerCase();
    if (searchTerm) {
      const filteredData = leaveRequestDuplicate.filter((item) =>
        item?.UserName?.toLowerCase()?.includes(searchTerm)
      );
      setLeaveBalence(filteredData);
    } else {
      setLeaveBalence(leaveRequestDuplicate);
    }
  };
  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);
  return (
    <>
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <>
          <div
            className={
              showSidebar
                ? "main-container-of-all-employees-Attendance-Balance"
                : "main-container-of-all-employees-page-new-Attendance-management"
            }
          >
            <div className="inner-container-of-all-employees-page-Balance ">
              <div className="header-of-employees-page-Balance row">
                <div className="all-employee-Attendance-Balance col">
                  <h4>Leave Balance</h4>
                </div>
                <div className="all-employees-Attendance-Balance col">
                  <div className="home-icon-Attendance-Balance">
                    <BiHomeAlt className="home-icon-header-Attendance-Balance" />
                  </div>
                  <div className="arrow-icon-Attendance-Balance">
                    <MdKeyboardArrowRight />
                  </div>
                  <div className="employee-text-Attendance-Balance">
                    <p>Leave </p>
                  </div>
                  <div className="arrow-icon-Attendance-Balance">
                    <MdKeyboardArrowRight />
                  </div>
                  <div className="all-employee-text-Attendance-Balance">
                    <p>Leave Balance</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="body-part-outer-Attendance-Balance">
              <div className="inner-body-container-of-employee-Attendance-Balance row-12">
                <div className=" first-side-in-body-Attendance-Balance col-6">
                  <div className="employee-text-in-Attendance-Balance">
                    <h2>Leave Balance</h2>
                  </div>
                  <div className="input-for-search-in-employee-Attendance-Balance">
                    <MdSearch className="search-icon-in-Attendance-Balance" />
                    <input
                      type="text"
                      placeholder="Search by name"
                      onChange={(e) => handleDataSearch(e)}
                    />
                  </div>
                </div>
              </div>
              <div className="table-in-all-emplyee-Attendance-Balance">
                <table className="table-main-Attendance-Balance">
                  <thead className="thead-main-Attendance-Balance">
                    <tr className="row-12">
                      <th className="col-1">Sr.no</th>
                      <th className="image-class-Balance col-1 ">Image</th>
                      <th className="image-class-Balance col-1 ">Name</th>
                      <th className="image-class-Balance col-1 ">
                        Previous Year
                      </th>
                      <th className="image-class-Balance col-1 ">
                        Current Year
                      </th>
                      <th className="image-class-Balance col-1 ">Sick Leave</th>

                      <th className="image-class-Balance col-1 ">Total </th>
                      <th className="image-class-Balance col-1 ">Accepted</th>
                      <th className="image-class-Balance col-1 ">Rejected</th>
                      <th className="image-class-Balance col-1 ">Carry Over</th>
                    </tr>
                  </thead>

                  <tbody className="tbody-main-Attendance-Balance">
                    {LeaveBalance?.length ? (
                      <>
                        {LeaveBalance?.sort((a, b) =>
                          a?.userName?.toLowerCase() >
                          b?.userName?.toLowerCase()
                            ? 1
                            : -1
                        ).map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                      
                                {/* {item?.imageurl ? (
                                      item?.imageurl && (
                                        <img
                                          className="image-of-header"
                                          src={item.imageurl}
                                          // alt="Profile Image"
                                        />
                                      )
                                    ) : (
                                    )} */}
                                    <img src={tableimg} alt={dummyimage} className="profile-icon-header"/>
                            </td>
                            <td> {item?.UserName}</td>
                            <td>{item?.previousYearLeave}</td>
                            <td>{item?.CasualLeave}</td>
                            <td>{item?.SickLeave}</td>
                            <td>{parseInt(item?.CasualLeave) + parseInt(item?.SickLeave)}</td>
                            {/* <td>---</td> */}
                            <td>{item?.Accepted}</td>
                            <td>{item?.Rejected}</td>
                            <td>{item?.CarryOver}</td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <>
                        <tr className="no-record-found-tr-dashboard">
                          <td colSpan="10">No record found</td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      </div>
    </>
  );
};
export default LeaveBalance;
